import Footer from "../../components/Footer";
import Header from "../../components/Header";
import RapidInspectionAssessment from "../../components/Service/Subservice/ria"; 
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function RIAPage() {
    return (
        <>
            <Header/>
            <SubServiceBanner title={"Rapid Inspection & Assessments (RIA)"}/>
            <RapidInspectionAssessment/>
            <Footer/>
        </>
    )
}